module.exports = __webpack_public_path__ + "img/icon_budget.f65cdbe2.png";